import React from "react";

const ServiceDetailsSection = () => {
  const detailedSections = [
    {
      id: "software",
      title: "Software Solutions",
      heading: "Innovative Software Solutions",
      description:
        "Our team of experts specializes in delivering tailored software solutions to meet your unique business needs, ensuring efficiency, transparency, and innovation in every project.",
      items: [
        {
          icon: "fas fa-desktop",
          title: "ERP Systems",
          desc: "Comprehensive enterprise resource planning solutions",
        },
        {
          icon: "fas fa-mobile-alt",
          title: "Mobile & Web Apps",
          desc: "Custom application development for all platforms",
        },
        {
          icon: "fas fa-building",
          title: "Property Management",
          desc: "Specialized lease and property management software",
        },
        {
          icon: "fas fa-chart-line",
          title: "Sales Force Automation",
          desc: "Advanced sales process automation tools",
        },
      ],
    },
    {
      id: "ifrs",
      title: "IFRS Services",
      heading: "Comprehensive Business Solutions",
      description:
        "From initial consultation to ongoing maintenance, we support your business at every stage with tailored solutions and strategic guidance.",
      items: [
        {
          icon: "fas fa-calculator",
          title: "IFRS & Financial",
          desc: "Expert consultation and compliance maintenance",
        },
        {
          icon: "fas fa-chart-pie",
          title: "Business Development",
          desc: "Strategic planning and growth consulting",
        },
        {
          icon: "fas fa-balance-scale",
          title: "Tax & Audit",
          desc: "Professional tax consulting and auditing",
        },
        {
          icon: "fas fa-chalkboard-teacher",
          title: "Training & Support",
          desc: "Comprehensive training and maintenance support",
        },
      ],
    },
    {
      id: "deployment",
      title: "System Deployment",
      heading: "Comprehensive System Deployment",
      description:
        "Our system deployment services ensure seamless integration and operation of Quality Management Systems (QMS) and Food Safety Management Systems (FSMS).",
      items: [
        {
          icon: "fas fa-search",
          title: "Gap Analysis",
          desc: "Identify and address system gaps",
        },
        {
          icon: "fas fa-file-alt",
          title: "Documentation",
          desc: "Comprehensive system documentation",
        },
        {
          icon: "fas fa-certificate",
          title: "Certification",
          desc: "Support for certification process",
        },
        {
          icon: "fas fa-cogs",
          title: "Implementation",
          desc: "End-to-end implementation support",
        },
      ],
    },
  ];

  return (
    <div className="container-fluid py-5 bg-light">
      <div className="container py-5">
        {detailedSections.map((section, idx) => (
          <div
            className="row g-5 mb-5"
            data-aos="fade-up"
            data-aos-delay={100 + idx * 200}
            key={section.id}
          >
            <div className="col-12 text-center mb-4">
              <div className="section-badge d-inline-block">
                <h3 className="text-white mb-0">{section.title}</h3>
              </div>
              <h2
                className="mt-4 mb-3"
                style={{ color: "#A71717", fontWeight: 600 }}
              >
                {section.heading}
              </h2>
              <p className="mb-5 lead px-lg-5">{section.description}</p>
            </div>
            <div className="col-lg-10 mx-auto">
              <div className="row g-4 justify-content-center">
                {section.items.map((item, i) => (
                  <div className="col-md-6" key={i}>
                    <div className="service-item-detail p-4 border rounded hover-shadow text-center">
                      <div className="icon-box rounded-circle bg-light p-3 mx-auto mb-3">
                        <i className={`${item.icon} fa-2x`} style={{ color: "#FFAA00" }}></i>
                      </div>
                      <h5 className="mb-3">{item.title}</h5>
                      <p className="mb-0">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServiceDetailsSection;
